import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
// Install backend-URL rewriter FIRST. Production safety net that ensures
// API calls hit the current origin instead of any baked-in preview URL.
// See lib/apiPatch.js for the full why.
import "@/lib/apiPatch";
import "@/index.css";
import "@/i18n"; // Initialize i18n
import App from "@/App";

// Loading fallback for i18n
const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-100">
    <div className="text-center">
      <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <p className="text-gray-600">Loading...</p>
    </div>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Suspense fallback={<LoadingFallback />}>
      <App />
    </Suspense>
  </React.StrictMode>,
);
